import React from 'react';
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';

import CartTable from './Table/CartTable';
import determineCartCount from '../../helpers/cart/determineCartCount';
import determineHeaderImage from '../Layout/Header/determineHeaderImage';
import EmptyCart from './EmptyCart';
import CountdownTimer from '../CountdownTimer';
import siteInfoById from '../../constants/siteInfoById';
import isDataEmpty from '../../helpers/isDataEmpty';
import Subtotal from './Subtotal';

import {
	generateSubtotal,
	removeItemFromCart,
	updateItemsInCart
} from '../../containers/Cart/cartSlice';

import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';

const CartLanding = (props) => {
	const {
		cartData,
		generateSubtotal,
		removeItemFromCart,
		siteId,
		subtotal,
		updateItemsInCart,
		userBalance
	} = props;

	const navigate = useNavigate();

	if (isDataEmpty(cartData)) {
		return (
			<>
				<Stack
					alignItems='center'
					spacing={5}
					component='header'
					className='filterbg'
					py={2}
					sx={{
						cursor: 'pointer',
						width: '100%',
						background: (theme) => theme.palette.common.white,
						position: 'fixed',
						top: 0,
						px: { xs: 1, md: 0 },
						zIndex: 99
					}}
				>
					<Link to='/' onClick={() => window.scrollTo({ top: 0 })}>
						<Box
							component='img'
							src={determineHeaderImage(siteId)}
							alt={`${siteInfoById[siteId].name} Logo`}
							className='filter'
							sx={{
								height: { xs: '39px', md: '60px' }
							}}
						/>
					</Link>
				</Stack>
				<EmptyCart />
			</>
		);
	}

	return (
		<>
			<Stack
				component='header'
				alignItems='center'
				className='filterbg'
				py={2}
				sx={{
					width: '100%',
					background: (theme) => theme.palette.common.white,
					position: 'fixed',
					top: 0,
					px: { xs: 1, md: 0 },
					zIndex: 99
				}}
			>
				<Stack
					direction='row'
					justifyContent='space-between'
					alignItems='center'
					sx={{
						width: { xs: '98%', sm: '96%', lg: '85%', xl: '65%' }
					}}
				>
					<Stack className='togglebg'>
						<Link to='/' onClick={() => window.scrollTo({ top: 0 })}>
							<Box
								component='img'
								src={determineHeaderImage(siteId)}
								alt={`${siteInfoById[siteId].name} Logo`}
								className='filter'
								sx={{
									height: { xs: '39px', md: '60px' },
									'&:hover': {
										opacity: 0.8
									}
								}}
							/>
						</Link>
					</Stack>
					<IconButton
						sx={{ color: 'common.black' }}
						className='filter'
						onClick={() => navigate('/cart')}
					>
						<Badge badgeContent={determineCartCount(cartData)} color='primary'>
							<ShoppingCartOutlinedIcon sx={{ fontSize: { xs: '28px', sm: '31px', md: '40px' } }} />
							<Typography sx={{ display: 'none' }}>Cart</Typography>
						</Badge>
					</IconButton>
					<Stack
						sx={{
							position: 'absolute',
							top: {
								xs: '25px',
								md: '30px'
							},
							right: {
								xs: '75px',
								sm: '95px',
								md: '109px',
								lg: '200px',
								xl: '40px'
							}
						}}
					>
						<CountdownTimer />
					</Stack>
				</Stack>
			</Stack>

			<Stack
				className='filter'
				sx={{
					background: (theme) => theme.palette.common.white,
					pt: { xs: 10, md: 13 },
					px: { xs: 2, xl: 3 }
				}}
			>
				<Stack
					sx={{
						background: (theme) => theme.palette.common.white,
						width: { xs: '99%', lg: '87%', xl: '67%' },
						mx: 'auto'
					}}
				>
					<Typography
						variant='h1'
						sx={{
							textAlign: 'left',
							fontSize: { xs: '1.5em', md: '1.8em', lg: '2.3em' },
							fontWeight: '500'
						}}
					>
						My Cart
					</Typography>
				</Stack>
			</Stack>
			<Stack
				alignItems='center'
				className='filter'
				spacing={5}
				sx={{
					pt: 3,
					background: (theme) => theme.palette.common.white,
					pb: { xs: 3, sm: 19 }
				}}
			>
				<CartTable
					data={cartData}
					generateSubtotal={generateSubtotal}
					removeItemFromCart={removeItemFromCart}
					siteId={siteId}
					subtotal={subtotal}
					updateItems={updateItemsInCart}
					userBalance={userBalance}
				/>
				<Stack
					direction='row'
					justifyContent='flex-end'
					sx={{ width: { xs: '92%', sm: '96%', lg: '85%', xl: '65%' } }}
				>
					<Subtotal data={cartData} subtotal={subtotal} generateSubtotal={generateSubtotal} />
				</Stack>
			</Stack>
		</>
	);
};

CartLanding.propTypes = {
	cartData: PropTypes.array,
	generateSubtotal: PropTypes.func,
	removeItemFromCart: PropTypes.func,
	siteId: PropTypes.number,
	subtotal: PropTypes.number,
	updateItemsInCart: PropTypes.func,
	userBalance: PropTypes.object
};

const mapStateToProps = (state) => {
	return {
		cartData: state.cartSlice.cartData,
		siteId: state.authSlice.siteId,
		subtotal: state.cartSlice.subtotal,
		userBalance: state.authSlice.userBalance.data
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		generateSubtotal: () => {
			dispatch(generateSubtotal());
		},
		removeItemFromCart: (payload) => {
			dispatch(removeItemFromCart(payload));
		},
		updateItemsInCart: (payload) => {
			dispatch(updateItemsInCart(payload));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(CartLanding);
